var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_vm._t("link",[_c('a',{staticClass:"text-white hover:bg-indigo-500 hover:bg-opacity-75 px-3 py-2 rounded-md text-sm font-medium",class:isActive ? _vm.getNavItemActiveCss : '',attrs:{"href":href},on:{"click":navigate}},[_vm._t("default")],2)])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }